export class Dependent {
	id: number;
	firstName: string;
	middleName: string;
	lastName: string;
	suffix: string;
	dependentAge: number;
	dependentDateOfBirth: string | Date;
	dependentGender: string;
	dependentRelationship: string;
	dependentSsn: string;
	smokerStatus: string;
	dependentRelationshipDetail: string;

	constructor() {
		this.id = 0;
		this.firstName = '';
		this.middleName = '';
		this.lastName = '';
		this.suffix = '';
		this.dependentAge = 0;
		this.dependentDateOfBirth = null;
		this.dependentGender = '';
		this.dependentRelationship = '';
		this.dependentSsn = '';
		this.smokerStatus = '';
		this.dependentRelationshipDetail = '';
	}
}

export const dependentPlaceholderValues = {
	firstName: 'First Name',
	middleName: 'Middle Name',
	lastName: 'Last Name',
}
